export default __webpack_public_path__ + "static/media/mobile.fb513d8b.svg";